import { createSelector } from "reselect";
import { getEnsemblTranscripts } from "./EnsemblTranscripts.selectors";
import { getRefseqTranscripts } from "./RefseqTranscripts.selectors";

const getIfTranscriptsExist = createSelector(
  getEnsemblTranscripts,
  getRefseqTranscripts,
  (ensemblTranscripts, refseqTranscripts) => {
    return Boolean(ensemblTranscripts || refseqTranscripts);
  }
);

export { getIfTranscriptsExist };
